/**
 * The writers for UK public-sector applications: the Civil Service
 * application and the NHS supporting statement. English only, one URL each
 * (no /cs or /de copy), so they are linked only where the page is in English:
 * the homepage's "For UK applicants" section and the Features menu, as well
 * as the footer (components/AppFooter.vue).
 */
export interface UkTool {
  id: 'civil-service' | 'nhs'
  path: string
  title: string
  description: string
  /** Bootstrap icon class. */
  icon: string
}

export const UK_TOOLS: UkTool[] = [
  {
    id: 'civil-service',
    path: '/civil-service-application',
    title: 'Civil Service application',
    description: 'STAR behaviour statements and a personal statement for one Civil Service Jobs advert, pitched at its grade, from your own CV.',
    icon: 'bi-bank',
  },
  {
    id: 'nhs',
    path: '/nhs-supporting-statement',
    title: 'NHS supporting statement',
    description: 'Evidence for every criterion in the person specification, box by box for NHS Jobs or one statement for Trac, from your own CV.',
    icon: 'bi-heart-pulse',
  },
]
